import { useEffect } from 'react';
import { useFrame, useThree } from '@react-three/fiber';
import type { Renderer } from 'three/webgpu';
import { usePanelStore } from '../store/panelStore';
import type { ScreenTexture } from './screen/ScreenTexture';

/**
 * Renders the instrument display into its own target once per frame, before
 * the main pass reads it.
 *
 * Priority 1 puts this ahead of the post-processing pass at priority 2, and any
 * positive priority tells R3F not to issue a render of its own.
 */
export function ScreenDriver({ screen }: { screen: ScreenTexture }) {
  const renderer = useThree((state) => state.gl) as unknown as Renderer;

  useEffect(() => () => screen.dispose(), [screen]);

  useFrame((_, delta) => {
    screen.update(usePanelStore.getState(), delta);
    screen.render(renderer);
  }, 1);

  return null;
}
